<template>
  <div>
    <!-- <div class="search-wrapper">
      <span>地区：</span>
      <Input v-model="searchArea" style="width:80px;margin-right:5px;"></Input>
      <span>项目名称：</span>
      <Input v-model="searchName" style="width:200px;margin-right:5px;"></Input>
      <Button type="primary" @click="searchColumns">搜索</Button>
      <span style="color:#ed3f14;padding:5px;">(数据不同步，请先到旧内网使用)</span>
    </div>
    <Table :columns="columns" :data="projectList" style="margin-top:5px;"></Table> -->
    <!-- <Page :total="pageTotal" show-elevator show-total style="margin-top:5px;" @on-change="pageChange"></Page> -->
    <project-table :operateColumns="operateColumns" :extraQuery="extraQuery"></project-table>
    <Modal class="eva-modal" :title="evaluationTitle" v-model="evaluationVisible" :mask-closable="false" width="100%">
      <iframe :src="evaluationUrl" style="width:100%;height:100%;"></iframe>
      <div slot="footer">

      </div>
    </Modal>
    <Modal class="modal" title="评标文件" v-model="bidFileVisible" width="1000">
      <iframe :src="bidFileUrl" style="width:100%;height:600px;"></iframe>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
import requestUrls from '@/lib/requestUrls'
import ProjectTable from '@/components/projectTable'
import { getProjectPermission } from "@/lib/projectPermission"

export default {
  components: {
    ProjectTable
  },
  data() {
    return {
      operateColumns: [
        {
          title: '操作',
          width: 250,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.bidFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=%E6%96%87%E4%BB%B6%E6%B1%87%E6%80%BB/main.cpt&op=write&NPID=${params.row.id}`
                    this.bidFileVisible = true
                  }
                }
              }, '评标文件模板'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: async () => {
                    this.$Spin.show()
                    try {
                      let rep = await ajax.get(requestUrls.ClMeetingRoom.GetRoomList, {
                        params: {
                          filter: `clProjectDb.id == "${params.row.id}"`,
                          sorting: 'id'
                        }
                      })
                      this.$Spin.hide()
                      if (rep.data.success) {
                        if (rep.data.result.items.length === 0) {
                          this.$Message.info('请先对此项目进行会议室预约')
                        } else {
                          this.$Spin.show()
                          // 跳转至新电子评标
                          userAjax.post(`/api/services/app/Synchronize/SearchSecretByCurrentUser`).then(res => {
                            this.$Spin.hide()
                            window.open(`http://qy.chinapsp.cn:8879/#/?importCode=${res.data.result.replace(new RegExp("\\+","g"),"%2B")}&importprojectFull=${params.row.projectFull}`)
                          })
                        }
                      } else {
                        this.$Message.error('操作失败')
                      }
                    } catch (err) {
                      console.error(err)
                      this.$Spin.hide()
                      this.$Message.error('操作失败')
                    }
                  }
                }
              }, '电子评标'),
            ])
          }
        }
      ],
      projectList: [],
      searchName: '',
      searchArea: '',
      permission: {
        type: ' and type=="开评标" and roomId >= "0"',
      },
      pageTotal: 0,
      currentPage: 1,
      evaluationVisible: false,
      evaluationUrl: '',
      bidFileUrl: '',
      bidFileVisible: false,
      evaluationTitle: '',
      extraQuery: {
        rolePermission: ''
      }
    }
  },
  methods: {
    async getBidProject(page, { searchName = '', searchArea = '' } = {}, { type = '' } = {}) {
      this.currentPage = page
      // 筛选今天之后的开评标
      let time = new Date()
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()
      time = `${year}-${month}-${day}`
      let timeSearch = ` and start > "${time}"`

      let nameSearch = searchName ? ` and title.Contains("${searchName}")` : ''
      let areaSearch = searchArea ? ` and area.Contains("${searchArea}")` : ''
      let filter = nameSearch + type + timeSearch + areaSearch
      filter = filter.slice(5)
      let rep = await ajax.get(requestUrls.AbpRoom.getPaged, {
        params: {
          filter: filter,
          sorting: 'start',
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      })
      if (rep.data.success) {
        this.projectList = rep.data.result.items
        this.pageTotal = rep.data.result.totalCount
      }
    },
    searchColumns() {
      this.getBidProject(this.currentPage, { searchName: this.searchName, searchArea: this.searchArea }, { type: this.permission.type })
    },
    pageChange(page) {
      this.getBidProject(page, { searchName: this.searchName, searchArea: this.searchArea }, { type: this.permission.type })
    }
  }
}
</script>

<style lang="less">
.modal {
  .ivu-modal {
    top: 20px;
  }
}
.eva-modal {
  .ivu-modal {
    top: 0;
    height: 100%;
  }
  .ivu-modal-content {
    height: 100%;
  }
  .ivu-modal-body {
    height: 90%;
  }
}
</style>
